import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { getHomeData } from "../../data/home.js";
import { toast } from "react-toastify";
import "./form.css";

const TrialForm = ({
  buttonClassName = "",
  buttonStyle = {},
  isHomePage = false,
  className = ""
}) => {
  const homeData = getHomeData();
  const trialFormConfig = homeData.trialForm;
const { GymDetail } = trialFormConfig;
  const initialState = trialFormConfig.fields.reduce((acc, field) => {
    acc[field.name] = "";
    return acc;
  }, {});

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const field = trialFormConfig.fields.find(f => f.name === name);
    const processedValue = field?.type === "select" ? value : value.trim();
    
    setFormData({
      ...formData,
      [name]: processedValue
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ""
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName || formData.firstName.trim() === "") {
      newErrors.firstName = "First name is required";
    }

    if (!formData.lastName || formData.lastName.trim() === "") {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.mobile || formData.mobile.trim() === "") {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile.trim())) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number";
    }

    if (!formData.gender || formData.gender === "") {
      newErrors.gender = "Gender is required";
    }

    if (!formData.preferredClass || formData.preferredClass === "") {
      newErrors.preferredClass = "Preferred class is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fill in all required fields correctly.");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        first_name: formData.firstName.trim(),
        last_name: formData.lastName.trim(),
        mobile_number: formData.mobile.trim(),
        gender: formData.gender,
        preferred_classes: formData.preferredClass
      };

      const response = await fetch(
        "https://fitness.guidework.in/sendmail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      );

      const result = await response.json();

     if (response.ok && result.status) {
  toast.success(result.message || "Message received successfully!");
  const name = `${formData.firstName.trim()} ${formData.lastName.trim()}`;
  const phone = formData.mobile.trim();
const message =
` *New Trial Class Enquiry!*

Hello *${GymDetail.GYM_NAME}!*

Hii I'm *${name}* I would like to join a trial class at your gym.

 *Name:* ${name}
 *Mobile:* ${phone}
 *Gender:* ${formData.gender}
 *Preferred Class:* ${formData.preferredClass}

_Please contact me as soon as possible to confirm my trial slot._`;

  const waUrl = `https://wa.me/+60${GymDetail.ORG_WHATSAPP}?text=${encodeURIComponent(message)}`;
  window.open(waUrl, "_blank");

  setFormData(initialState);
  setErrors({});
} else {
        if (result.errors) {
          const errorMessages = Object.values(result.errors).join(", ");
          toast.error(errorMessages || result.message || "Validation failed");
        } else {
          toast.error(result.message || "Something went wrong!");
        }
      }
    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("Server error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderField = (field) => {
    if (field.type === "select") {
      return (
        <>
          <Form.Select
            name={field.name}
            value={formData[field.name] || ""}
            onChange={handleChange}
            className={`trial-input ${errors[field.name] ? "is-invalid" : ""}`}
          >
            <option value="">Select {field.label}</option>
            {field.options.map((opt, i) => (
              <option key={i} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </Form.Select>
          {errors[field.name] && (
            <div className="text-danger small mt-1">{errors[field.name]}</div>
          )}
        </>
      );
    }

    return (
      <>
        <Form.Control
          type={field.type}
          name={field.name}
          placeholder={field.placeholder}
          value={formData[field.name] || ""}
          onChange={handleChange}
          className={`trial-input ${errors[field.name] ? "is-invalid" : ""}`}
        />
        {errors[field.name] && (
          <div className="text-danger small mt-1">{errors[field.name]}</div>
        )}
      </>
    );
  };

  return (
    <div className={`trial-form-container ${className}`.trim()}>
      <Container fluid className="col-md-10 mx-auto">
        <div className="trial-form-box">

          <h2 className="trial-title ms-md-3">
            {trialFormConfig.title}
          </h2>

          <p className="trial-subtitle ms-md-3">
            {trialFormConfig.subtitle}
          </p>

          <Form onSubmit={handleSubmit}>
            <Row className="g-4">

              {trialFormConfig.fields.map((field, i) => (
                <Col xs={12} md={6} key={i}>
                  <div className={isHomePage ? "col-11 mx-auto" : ""}>
                    <Form.Label className="trial-label">
                      {field.label}
                    </Form.Label>

                    {renderField(field)}
                  </div>
                </Col>
              ))}

            </Row>

            <div className="trial-btn-wrapper">
              <Button
                type="submit"
                variant="none"
                className={`trial-btn mt-3 ${buttonClassName}`.trim()}
                style={buttonStyle}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </div>

          </Form>

        </div>
      </Container>
    </div>
  );
};

export default TrialForm;